var cov_1wk08c4pin = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Switch/index.ts",
      hash = "d5dbff5d5a637ac72a3caeb3a373c6822bc5a615",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Switch/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 10,
          column: 9
        }
      },
      "1": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 38
        }
      },
      "2": {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 13,
          column: 23
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import inputable from '../Form/inputable';
import { compose } from '../utils/func';
import Switch from './Switch';
import { consumer } from '../Checkbox/context';
var exports = (cov_1wk08c4pin.s[0]++, compose(inputable, consumer)(Switch));
cov_1wk08c4pin.s[1]++;
exports.displayName = 'ShineoutSwitch';
cov_1wk08c4pin.s[2]++;
exports.Switch = Switch;
export default exports;